import { exportLoanRegisterRequests } from "../services/loan.service";
import { DocumentUrl, PaginationInfo } from "./cartable.model";

export interface GetSuppliersResponse {
  id: number | undefined;
  title: string | undefined;
  logo: string | undefined;
}

export interface GetSuppliersResponse {
  allowAddSupplier: boolean;
  suppliers: suppliers[];
}
export type suppliers = {
  id: number | undefined;
  title: string | undefined;
  storeTitle: string | null;
  logo: string | undefined;
  isTopRated: boolean;
  isOfflineStore: boolean;
  isOnlineStore: boolean;
  websiteUrl: string | null;
  supplierStatus: string | undefined;
  supplierStatusTitle: string | undefined;
};

export interface GetSuppliersInfoResponse {
  supplierTitle: supplierTitle;
  supplierAddresses: supplierAddresses[];
  supplierTemplates: supplierTemplates[];
  creditManagePermission: boolean;
  userManagePermission: boolean;
  addressManagePermission: boolean;
  stateManagePermission: boolean;
  assignedLoansCount: number;
  assignedLoansAmountRial: number;
  settledLoansCount: number;
  settledLoansAmountRial: number;
}

export interface GetSupplierInfoRequest {
  supplierId: number | undefined;
}

export interface DeactivateSupplierRequest {
  supplierId: number | undefined;
}

export type DeactivateSupplierResponse = boolean;

export interface GetSuppliersCreditHistoryRequest {
  supplierId: number | undefined;
  loanTemplateId: number | undefined;
}

export interface GetSuppliersCreditHistoryResponse {
  amount: number | undefined;
  creditStatus: string | undefined;
  creditStatusTitle: string | undefined;
  requestorUserTitle: string | undefined;
  reviewerUserTitle: string | undefined;
  requestDatePersian: string | undefined;
  reviewDatePersian: string | undefined;
}

export interface GetFinancialSuppliersForCreditRequestRequest {
  supplierId: number | undefined;
}

export interface GetFinancialSuppliersForCreditRequestResponse {
  key: number | undefined;
  value: string | undefined;
}

export interface GetLoanTemplatesForCreditRequestRequest {
  supplierId: number | undefined;
  financialSupplierId: number | undefined;
}

// export interface GetLoanTemplatesForCreditRequestResponse {
//   key: number | undefined;
//   value: string | undefined;
// }

export interface AddCreditRequest {
  financialSuppliersValue?: number | undefined;
  supplierId: number | undefined;
  loanTemplateId: number | undefined;
  creditAmountRial: number | undefined;
}

export type AddCreditResponse = boolean;

type supplierTitle = {
  id: number | undefined;
  title: string | undefined;
  storeTitle: string | undefined;
  logo: string | undefined;
  isTopRated: boolean;
  isOfflineStore: boolean;
  isOnlineStore: boolean;
  websiteUrl: string | null;
  supplierStatus: string | undefined;
  supplierStatusTitle: string | undefined;
};

type supplierAddresses = {
  id: number | undefined;
  telNumbers: string | undefined;
  address: string | undefined;
  email: string | undefined | null;
  orderIx: number | undefined | null;
};

export type supplierTemplates = {
  loanTemplateId: number | undefined;
  loanTemplateTitle: string | undefined;
  card: string | undefined;
  financialSupplier: string | undefined;
  loanRequestsCount: number | undefined;
  loanRequestsAmountRial: number | undefined;
  remainingCreditAmountRial: number | undefined;
  userProfitPercent: number | undefined;
  realProfitPercent: number | undefined;
  maximumAmountRial: number | undefined;
  expireDate: string | undefined;
};

export class GetOnlineInstallmentReportRequest {
  paginationInfo: PaginationInfo | undefined;
  filter: Filter | undefined;
}
export class Filter {
  supplierIds: number[] | undefined;
  loanTemplateIds: number[] | undefined;
  nationalCode: string | undefined;
  cartableTitle?: string;
}

export interface GetOnlineInstallmentReportResponse {
  referenceKey: string;
  firstName: string;
  lastName: string;
  fullName: string;
  nationalCode: string;
  mobileNumber: string;
  supplierTitle: string;
  financialSupplierTitle: string;
  loanAmount: number;
  installmentAmount: number;
  installmentCount: number;
  paidInstallmentCount: number;
  lastPaymentDate: Date;
  lastPaymentDate_Persian: string;
  overduedInstallmentCount: number;
  overduedInstallmentAmount: number;
  penaltyAmount: number;
  totalOverDuedDeptAmount: number;
  loanTemplateId: number | undefined;
  loanTemplateTitle: string | undefined;
  card: string | undefined;
  financialSupplier: string | undefined;
  loanRequestsCount: number | undefined;
  loanRequestsAmountRial: number | undefined;
  remainingCreditAmountRial: number | undefined;
  userProfitPercent: number | undefined;
  realProfitPercent: number | undefined;
  maximumAmountRial: number | undefined;
  expireDate: string | undefined;
  assignedLoansCount: number | undefined;
  assignedLoansAmountRial: number | undefined;
  settledLoansCount: number | undefined;
  settledLoansAmountRial: number | undefined;
}

export interface addNewSupplierRequest {
  title: string | null;
  storeTitle: string | null;
  isTopRated: boolean;
  isOfflineStore: boolean;
  isOnlineStore: boolean;
  websiteUrl: string | null;
  users: any[];
  logo?: any;
}

export interface addNewSupplierResponse {
  supplierId: number;
}

export type users = {
  firstName: string | null;
  lastName: string | null;
  mobileNo: string | null;
  fullAccess: boolean;
  cityId: number | null;
};

export interface getSupplierUsersResponse {
  id: number;
  firstName: string;
  lastName: string;
  isActive: boolean;
  isSuperUser: boolean;
  createDate: string;
  createDate_Persian: string;
  modifyDate: string;
  modifyDate_Persian: string;
  nationalCode: string;
  mobileNumber: string;
  city: string;
  cityId?: number;
}

export interface getSupplierUsersRequest {
  supplierId: number;
}

export interface getSupplierAddresesResponse {
  id: number;
  telNumbers: string;
  address: string;
  email: string;
  orderIx: number;
}

export interface AddSupplierAddressRequest {
  supplierAddressId: number;
  supplierId: number | null;
  address: string;
  telNumbers: string;
  email: string;
}

export interface AddSupplierAddressResponse extends supplierAddresses {}

export interface EditSupplierAddressRequest extends AddSupplierAddressRequest {}

export type AddSupplierUserRequest = {
  supplierId: number;
  mobileNumber: string;
  firstName: string;
  lastName: string;
  nationalCode?: string;
  isSuperUser: boolean;
  cityId: number;
};

export interface AddSupplierUsersResponse extends AddSupplierUserRequest {}

export interface EditSupplierUserRequest {
  id: number;
  firstName: string;
  lastName: string;
  isSuperUser: boolean;
  cityId: number;
  isActive: boolean;
}

export interface GetLoansReportResponse {
  referenceKey: string;
  // bankAssignDate: Date;
  bankAssignDatePersian: string;
  // creationDate: Date;
  creationDatePersian: string;
  loanRequestStatus: string;
  loanRequestStatusTitle: string;
  customerNationalCode: string;
  customerFirstName: string;
  customerLastName: string;
  customerMobileNumber: string;
  organizationTitle: string;
  financialSupplierTitle: string;
  repaymentType: string;
  repaymentTypeTitle: string;
  amount: number;
  customerFeeAmount: number;
  durationByMonth: number;
  stepSpaceByMonth: number;
}

export interface GetSalesReportResponse {
  saleKey: string;
  saleDatePersian: string;
  saleType: string;
  saleTypeTitle: string;
  saleStatus: string;
  saleStatusTitle: string;
  storeTitle: string;
  branchTitle: string;
  customerNationalCode: string;
  customerFirstName: string;
  customerLastName: string;
  customerMobileNumber: string;
  totalAmount: number;
  factorNumber: string;
  cashPaymentAmount: number;
  gateway: string;
  transactionNumber: string;
  traceNumber: string;
}
